import React from "react";
import styles from "../../assets/scss/componnetScss/footer.module.scss";
import { footerData } from "../../assets/config/config";



export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className="container">
        <div className={styles.containers}>
          <div className={styles.footerLeft}>
            <h2>{footerData.companyName}</h2>
            <p>{footerData.description}</p>
            <div className={styles.socialIcons}>
              {footerData.socialLinks.map((social, index) => (
                <a key={index} href={social.link}>
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          <div className={styles.footerCenter}>
            {footerData.columns.map((col, index) => (
              <div key={index}>
                <h4>{col.title}</h4>
                <ul>
                  <li>{col.name}</li>
                </ul>
                {/* <ul>
                  {col.links.map((link, linkIndex) => (
                    <li key={linkIndex}>
                      {link.name} 
                    </li>
                  ))}
                </ul> */}
              </div>
            ))}
          </div>

        

        </div>
      </div>

      {/* Bottom Section */}
      <div className={styles.footerBottom}>
        <div className="container">
          <div className={styles.wrp}>
            <p>
              {footerData.footerBottom.copyright} <span>{new Date().getFullYear()} All rights reserved</span> | Designed by  <a href={footerData.footerBottom.designer.link} target="_blank" rel="noopener noreferrer" >
                {footerData.footerBottom.designer.name}
              </a>
            </p>

            {/* <div className={styles.links}>
              {footerData.footerBottom.links.map((link, index) => (
                <a key={index} href="#">
                  {link}
                </a>
              ))}
            </div> */}

          </div>
        </div>
      </div>
    </footer>
  );
}

